import { useCallback } from 'react';
import { pathTo } from '../App/routes';
export { default as useBodyClass } from './useBodyClass';
export { default as useBreadcrumbs } from './useBreadcrumbs';
export { default as useChart } from './useChart';

export function usePath(leagueId, seasonId, teamId) {
  return useCallback(
    (name, model) => pathTo(name, leagueId, seasonId, teamId, model),
    [leagueId, seasonId, teamId],
  );
}
